module.exports = __webpack_public_path__ + "img/Tusk.3ad84f46.png";